var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCacti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cacti-a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A4DC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B8C06"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cacti-b",
    d: "M38.941152,16.06416 C38.463392,14.55664 37.501792,13.27344 36.023712,12.65616 C35.375072,12.38544 34.665952,12.29808 33.969312,12.3816 C32.050912,12.61168 30.992032,13.69936 31.021792,15.64304 C31.034912,16.48976 31.543392,18.3864 30.401312,18.7448 C30.325472,18.76848 30.239712,18.78128 30.168992,18.7448 C30.061792,18.68912 30.035872,18.54992 30.024992,18.4296 C29.975712,17.89392 29.993952,17.37456 30.010592,16.83856 C30.111072,13.63472 29.936672,10.48144 28.838432,7.4184 C27.882912,4.75312 25.906912,1.57808 22.864352,1.06032 C20.922272,0.72976 18.400352,1.78512 17.469152,3.564 C16.768032,4.90352 17.265632,6.50128 17.794272,7.80784 C19.327712,11.59824 20.498912,15.4536 19.583392,19.61136 C19.411552,20.3928 19.344672,21.70704 18.310432,21.41456 C17.336992,21.13872 18.090912,20.01584 18.290592,19.32432 C18.710752,17.86992 19.114272,16.40144 18.609312,14.9368 C18.089312,13.42768 17.121312,12.13552 15.464672,11.8136 C13.459552,11.42352 11.531232,11.876 10.333472,13.63312 C8.201952,16.76048 7.554272,20.24912 8.294112,23.99088 C8.874592,26.92432 12.467552,28.27344 15.325792,28.53424 C16.224672,28.61616 17.138272,28.61456 18.040672,28.56496 C19.266592,28.49808 19.680672,29.0984 19.552992,30.22032 C19.378272,31.75568 19.110752,33.26256 18.584672,34.7336 C17.844192,36.80432 17.509152,38.92016 17.825632,41.15952 C18.181792,43.67952 19.566112,45.09264 21.976992,45.53712 C24.890272,46.07376 27.796192,46.27472 30.526752,44.73904 C32.751712,43.48752 33.279072,42.436 32.456032,40.0136 C31.433312,37.00304 30.895392,33.93232 30.822432,30.77424 C30.794272,29.55632 30.913952,28.33456 30.984992,27.11536 C31.054432,25.92848 32.055392,25.92368 32.848032,25.7416 C34.556192,25.3496 36.232672,24.65424 37.485792,23.39344 C39.197472,21.6712 39.732192,18.56048 38.941152,16.06416"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "cacti-c",
    width: "116%",
    height: "111.1%",
    x: "-8%",
    y: "-5.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0.0117647059   0 0 0 0 0.419607843   0 0 0 0 0.00784313725  0 0 0 0.318164532 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#cacti-a)",
    xlinkHref: "#cacti-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cacti-c)",
    xlinkHref: "#cacti-b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCacti);
export default __webpack_public_path__ + "static/media/Cacti.8df2b919.svg";
export { ForwardRef as ReactComponent };